import Connect from './Connect';
import { Loading } from '../../components';
import { useCallAgents } from './useCallAgents';

const CallManagement: React.FC = () => {
  const { loading, agents } = useCallAgents();
  if (loading) return <Loading />;

  return (
    <>
      <Connect agents={agents} />
    </>
  );
};

export default CallManagement;
